import { updateDocToSubCollection, setDocToSubCollection, getDocFromCollection } from './dbUtils';

// get Guest User Session
export const getGuestUserSession = (guestId, sessionId) => {
	return getDocFromCollection(`guests/${guestId}/events/${sessionId}`);
};

export const registerGuestUserSession = async (guestId, sessionId, sessionData) => {
	setDocToSubCollection(`guests/${guestId}/events/${sessionId}`, { guestId, eventId: sessionId, ...sessionData });
	return { guestId, eventId: sessionId, ...sessionData };
};

export const updateGuestUserSession = async (guestId, sessionId, sessionData) => {
	updateDocToSubCollection(`guests/${guestId}/events/${sessionId}`, { guestId, eventId: sessionId, ...sessionData });
	return { guestId, eventId: sessionId, ...sessionData };
};

export const updateGuestUserSessionFeedback = async (guestId, sessionId, feedback) => {
	updateDocToSubCollection(`guests/${guestId}/events/${sessionId}`, { guestId, eventId: sessionId, feedback });
	return { guestId, eventId: sessionId, feedback };
};